<template>
    <div class="sidebar" style="width: initial;">
        <div class="text-center">
            <br />
        <span class="mt-2">
          <img
            v-if="studentProfileAuthorize == ''"
            width="50px"
            height="50px"
            src="../assets/img/icon/icondefault.svg"
          />
          <img
            v-else
            width="50px"
            height="50px"
            :src="photoURL"
            style="border-radius: 50%; border: 5px solid #fff"
          />
        </span>
        <span>
            <span class="custom-user-title text-black m-3"
              >Hello {{ user.name }}!</span
            >
            <label class="label-greeting text-black text center"
              >What do you want to do today? <br /><br />
              <span class="custom-credit text-center">O credits</span></label
            >
            
          </span>
          </div>
          <ul class="ml-2">
      <li>
        <span :class="{ 'active': activeMenuItem === 'home' }" @click="GoHome()"> <img src="../assets/img/icon/homegrey.svg" /> Home</span>
      </li>
      <li>
        <span :class="{ 'active': activeMenuItem === 'class' }" @click="GoClass()"> <img src="../assets/img/icon/iconBook.svg" /> Class</span>
      </li>
      <li>
        <span :class="{ 'active': activeMenuItem === 'tutor' }" @click="GoTutor()"><img src="../assets/img/icon/profile-circle.svg" />  Tutor</span>
      </li>
      <li>
        <span :class="{ 'active': activeMenuItem === 'notification' }" @click="GoNotification()"><img src="../assets/img/icon/iconBell.png" /> Notification</span>
      </li>
      <li>
        <span :class="{ 'active': activeMenuItem === 'package' }" @click="GoPackage()"><img src="../assets/img/icon/iconBook.svg" /> Package</span>
      </li>
      <li>
        <span :class="{ 'active': activeMenuItem === 'profile' }" @click="GoProfile()"><img src="../assets/img/icon/profile-circle.svg" /> Profile</span>
      </li>
    </ul>
    <CButton class="custom-btn-deactive ml-2 b-20" color="danger" @click="SignOut()"
                >Logout</CButton
              >
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        sidebarItems: [
          { id: 1, title: 'Home', path: '/ExistingUser' },
          { id: 2, title: 'Class', path: '/about' },
          { id: 3, title: 'Tutor', path: '/services' },
          { id: 4, title: 'Package', path: '/contact' },
          { id: 5, title: 'Profile', path: '/contact' }
        ],
        user: {},
        studentProfileAuthorize: "",
        activeMenuItem: ''
      };
    },
    async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetAuthorizeProfile(this.user.id);
            this.GetListChild(this.user.id);
            this.GetParentDetail(this.user.id);
            this.GetNews();
            this.GetTutorRating();
          }
        });
    },

    GetAuthorizeProfile() {
      this.$API
        .get(this.$GetProfilePhotoAuthorize + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentProfileAuthorize = response.data;
            this.photoURL =
              "https://pickiddo.com" + this.studentProfileAuthorize;
          }
        });
    },
    GoHome() {
      this.activeMenuItem = 'home'; 
      this.$router.push("/ExistingUser");
      
    },
    GoProfile() {
  if (this.user.userType == "parent") {
    this.activeMenuItem = 'profile'; // Set active menu item to 'profile' for parent
    this.$router.push("/ParentProfile/Profile");
  } else {
    this.activeMenuItem = 'profile'; // Set active menu item to 'profile' for tutor
    this.$router.push("/Tutor/TutorProfile");
  }
},
    GoClass() {
      this.activeMenuItem = 'class'; 
      this.$router.push("/Class/ClassMain");
    
    },
    GoTutor() {
      this.activeMenuItem = 'tutor';
      this.$router.push("/FindTutor/FindTutorMainpage");
    },
    GoPackage() {
      this.activeMenuItem = 'package'; 
     window.open("https://www.pickiddo.com/SignInUserAffiliate");
    },
    GoNotification() {
      this.activeMenuItem = 'notification'; 
      this.$router.push("/Notification");
    },
    SignOut: function () {
      return this.$API
        .get(this.$SignOut, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200) {
            this.$router.push("/LoginInformation");
          }
        });

    },
}
  };
  </script>
  
  <style scoped>
  .sidebar {
    width: 300px;
    background-color: #fff;
    margin-left:20px;
    border-radius:20px;
    height:90vh;
    margin:20px;
  }
  .active {
  color: blue; /* Apply blue color to the active menu item */
}
  
  .sidebar ul {
    list-style-type: none;
    padding: 0;
  }
  
  .sidebar li {
    padding: 10px;
  }
  
  .sidebar li:hover {
    background-color: #0085ff;
    color:#fff;
  }
  </style>
  